// Multi browser support
// Methods from http://www.html5rocks.com/en/tutorials/pagevisibility/intro/
function getHiddenProp() {
  const prefixes = ['webkit', 'moz', 'ms', 'o'];

  // if 'hidden' is natively supported just return it
  if ('hidden' in document) {
    return 'hidden';
  }

  // otherwise loop over all the known prefixes until we find one
  for (let i = 0; i < prefixes.length; i++) {
    if (prefixes[i] + 'Hidden' in document) {
      return prefixes[i] + 'Hidden';
    }
  }

  // otherwise it's not supported
  return null;
}

// Get the property name for this browser
const VISIBILITY_PROPERTY = getHiddenProp();
let VISIBILITY_CALLBACK = false; // NOOP
const VISIBILITY_EVENT =
  String(VISIBILITY_PROPERTY).replace(/[H|h]idden/, '') + 'visibilitychange';

function isHidden() {
  if (!VISIBILITY_PROPERTY) {
    return false;
  }
  return document[VISIBILITY_PROPERTY];
  // "hidden": the document is completely hidden from view
  // "visible": the document is at least partially visible on at least one display device
  // "prerender": the document is loaded off-screen and not visible (this value is optional; not all browsers will necessarily support it)
  // "unloaded": if the document is to be unloaded, then this value will be returned (this value is optional; not all browsers will necessarily support it)
}

function unbindEvent() {
  if (VISIBILITY_CALLBACK) {
    document.removeEventListener(VISIBILITY_EVENT, VISIBILITY_CALLBACK);
  }
}

function bindEvent(callback) {
  unbindEvent();
  VISIBILITY_CALLBACK = function() {
    callback(!isHidden());
  };

  document.addEventListener(VISIBILITY_EVENT, VISIBILITY_CALLBACK);
}

export default class Visibility {
  static enable(callback) {
    // Bind event for changes
    bindEvent(callback);

    // Also call it directly with current state
    callback(!isHidden());
  }

  static disable() {
    unbindEvent();
  }
}
